import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const PROCUREMENT_PACKAGE = FORM_FIELDS.PROCUREMENT_PACKAGE;

const {
  ALLOCATED_BUDGET,
  APPROVING_AUTHORITY,
  DOCUMENTS,
  FINANCIAL_CODE,
  FIRST_QUARTER_BUDGET,
  FOURTH_QUARTER_BUDGET,
  NAME,
  PACKAGE_DESCRIPTION,
  PACKAGE_REF_NO,
  PROCUREMENT_METHOD,
  PROCUREMENT_NATURE,
  PROCUREMENT_TYPE,
  SECOND_QUARTER_BUDGET,
  THIRD_QUARTER_BUDGET,
  PACKAGE_BUDGET_DETAILS,
  PACKAGE_BUDGET_TITLE,
} = PROCUREMENT_PACKAGE;

export const packageValidation = yup.object().shape({
  [NAME]: yup.string().required("Name is required"),
  [PACKAGE_REF_NO]: yup.string().required("Ref no. is required"),
  [PACKAGE_DESCRIPTION]: yup.string(),
  [FINANCIAL_CODE]: yup.string().required("Financial code is required"),
  [PROCUREMENT_NATURE]: yup
    .number()
    .typeError("Procurement Nature is required")
    .required("Procurement Nature is required"),
  [PROCUREMENT_TYPE]: yup
    .number()
    .typeError("Procurement type is required")
    .required("Procurement type is required"),
  [PACKAGE_BUDGET_DETAILS]: yup
    .array()
    .of(
      yup.object().shape({
        [PACKAGE_BUDGET_TITLE]: yup.string().required("Title is required"),
        [PROCUREMENT_METHOD]: yup
          .number()
          .typeError("Procurement method is required")
          .required("Procurement method is required"),
        [FIRST_QUARTER_BUDGET]: yup
          .number()
          .typeError("Please input a valid number")
          .required("Enter 0 if there is no budget"),
        [SECOND_QUARTER_BUDGET]: yup
          .number()
          .typeError("Please input a valid number")
          .required("Enter 0 if there is no budget"),
        [THIRD_QUARTER_BUDGET]: yup
          .number()
          .typeError("Please input a valid number")
          .required("Enter 0 if there is no budget"),
        [FOURTH_QUARTER_BUDGET]: yup
          .number()
          .typeError("Please input a valid number")
          .required("Enter 0 if there is no budget"),
      }),
    )
    .required("Package budget is required")
    .min(1, "Package budget is required"),
  [APPROVING_AUTHORITY]: yup
    .string()
    .required("Approving authority is required"),
  [ALLOCATED_BUDGET]: yup
    .number()
    .typeError("Please input a valid number")
    .required("Allocated budget is required"),

  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string().nullable(),
      }),
    )
    .nullable(),
  // .required("Document is required"),
});
